import type { ChangeEvent, FC } from 'react';
import classnames from 'classnames';

import { Input, version2 } from 'ui-components/components/input';

import type { WorkflowActionInputProps } from '../../registries/registry-types';
import styles from './generic-inputs.module.less';

export const TextParameterInput: FC<WorkflowActionInputProps> = ({ className, draft, onUpdate }) => (
  <Input
    className={className}
    onChange={(e: ChangeEvent<HTMLInputElement>) => onUpdate({ parameter: e.target.value })}
    value={draft.parameter ?? ''}
    version={version2}
  />
);

export const TextAreaParameterInput: FC<WorkflowActionInputProps> = ({ className, draft, onUpdate }) => (
  <textarea
    className={classnames(styles.textArea, className)}
    onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onUpdate({ parameter: e.target.value })}
    value={draft.parameter ?? ''}
  />
);

export const IntParameterInput: FC<WorkflowActionInputProps> = ({ className, draft, onUpdate }) => (
  <Input
    className={className}
    onChange={(e: ChangeEvent<HTMLInputElement>) => onUpdate({ intParameter: e.target.value ? Number(e.target.value) : null })}
    value={draft.intParameter !== null ? String(draft.intParameter) : ''}
    version={version2}
  />
);
